module.exports = __webpack_public_path__ + "static/media/bs.cbc10545.svg";